export const pageTypes = {
  catalogue: 'catalogue',
  common: 'common',
  dashboard: 'dashboard',
  detailsPage: 'detailsPage',
  favorites: 'favorites',
};
